import type { AppOptions } from '@app/types/profile/interfaces'

import { useProfileStore } from '@stores/profile'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

interface OptionsApiResponse {
  success: boolean
  message: string
  data: AppOptions
}

export const useOptionsApi = async (): Promise<AppOptions | null> => {
  const { $axios } = useNuxtApp()
  const profileStore = useProfileStore()

  const url = useAdminRoutes('admin.options')
  if (!url) return null

  try {
    const { data } = await $axios.get<OptionsApiResponse>(url)

    profileStore.setOptions(data.data)

    return data.data
  } catch (err: unknown) {
    console.error(err)
    return null
  }
}
